export const fmtDate = (d, showYear = false) =>
  new Date(d + "T12:00:00").toLocaleDateString("en-US", {
    month: "short", day: "numeric", ...(showYear ? { year: "2-digit" } : {}),
  });

export const fmtDuration = secs =>
  secs ? `${Math.floor(secs / 60)}m ${secs % 60}s` : null;

export const fmtTimer = secs =>
  `${String(Math.floor(secs / 60)).padStart(2, "0")}:${String(secs % 60).padStart(2, "0")}`;
